"use client"

import { useGetAllSubTraining } from "@/actions/sub-training"
import { useGetTrainingByCodeCombobox } from "@/actions/training"
import {
  useGetAllTypeTrainingComboBox,
  useGetTypeAllTrainingByNameComboBox,
} from "@/actions/type-training"
import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"
import BackgroundSlideshow from "@/components/common/background-slideshow"
import { formatDotString } from "@/lib/string"
import { cn } from "@/lib/tailwind-utils"
import { Check } from "lucide-react"
import { useRouter } from "next/navigation"
import { useState } from "react"
import { AiOutlineLoading3Quarters } from "react-icons/ai"

const PelatihanCombobox = ({
  name,
  className,
  placeholder,
  searchPlaceholder,
  isLoading = false,
  isSuccess = false,
  isError = false,
  value,
  setValue,
  choosedValue,
  handleChoosedValue,
  datas = [],
}) => {
  const [open, setOpen] = useState(false)

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="reset"
          role="combobox"
          aria-expanded={open}
          className={cn(
            "w-full  lg:col-span-2 p-4 border-b lg:border-b-0 col-span-7 lg:border-r flex h-full justify-between rounded-none  text-txt14_20",
            className,
          )}>
          {value
            ? formatDotString(
                datas.find((data) => data.value === value)?.label,
                50,
              )
            : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] max-h-[--radix-popover-content-available-height] p-0">
        <Command>
          <CommandInput placeholder={searchPlaceholder} />
          {isLoading && (
            <CommandList>
              <CommandGroup>
                {Array.from({ length: 1 }).map((_, index) => (
                  <CommandItem key={index + 1}>
                    <AiOutlineLoading3Quarters className="mr-2 h-4 w-4 animate-spin" />{" "}
                    Sedang memuat data...
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          )}
          {isSuccess && (
            <CommandList>
              <CommandEmpty>
                {name ? `${name} tidak ditemukan.` : "Data tidak ditemukan."}
              </CommandEmpty>
              <CommandGroup>
                {datas.map((data) => {
                  return (
                    <CommandItem
                      key={data.value}
                      value={data.value}
                      onSelect={(currentValue) => {
                        setValue(currentValue === value ? "" : currentValue)
                        // handleChoose(currentValue === value ? "" : currentValue)
                        handleChoosedValue(
                          choosedValue?.label === data?.label ? null : data,
                        )
                        setOpen(false)
                      }}>
                      <Check
                        className={cn(
                          "mr-2 h-4 w-4",
                          value === data.value ? "opacity-100" : "opacity-0",
                        )}
                      />
                      {data.label}
                    </CommandItem>
                  )
                })}
              </CommandGroup>
            </CommandList>
          )}
        </Command>
      </PopoverContent>
    </Popover>
  )
}

export default function Header() {
  const router = useRouter()
  const [choosedSubtraining, setChoosedSubTraining] = useState({})
  const [subTrainingSearch, setSubTrainingSearch] = useState("")
  const {
    data: allSubTraining,
    isFetching: isLoadingGetAllSubTraining,
    isSuccess: isSuccessGetAllSubTraining,
  } = useGetAllSubTraining()

  const handleChooseSubTraining = (value) => {
    if (!value) {
      setChoosedSubTraining({})
    }

    setChoosedSubTraining(value)
  }
  const {
    data: allTypeTraining,
    isFetching: isLoadingGetAllTypeTraining,
    isSuccess: isSuccessGetAllTypeTraining,
    // isError: isErrorGetAllTypeTraining,
  } = useGetAllTypeTrainingComboBox()

  const [trainingTypeSearch, setTrainingTypeSearch] = useState("")
  const [trainingTypeId, setTrainingTypeId] = useState("")

  const {
    data: allTrainingByType,
    isFetching: isLoadingGetAllTrainingByType,
    isSuccess: isSuccessGetAllTrainingByType,
    // isError: isErrorGetAllTrainingByType,
  } = useGetTypeAllTrainingByNameComboBox(trainingTypeId?.id)

  const [trainingCode, setTrainingCode] = useState("")
  const [trainingCodeSearch, setTrainingCodeSearch] = useState("")

  const {
    data: allSubTrainingByTrainingCode,
    isFetching: isLoadingGetAllSubTrainingByTrainingCode,
    isSuccess: isSuccessGetAllSubTrainingByTrainingCode,
    // isError: isErrorGetAllSubTrainingByTrainingCode,
  } = useGetTrainingByCodeCombobox(trainingCode.code)

  const [subTrainingCode, setSubTrainingCode] = useState("")
  const [subTrainingCodeSearch, setSubTrainingCodeSearch] = useState("")

  const handleChooseTypeTraining = (value) => {
    if (!value) {
      setTrainingCodeSearch("")
      setSubTrainingCodeSearch("")
    }
    if (value?.label !== trainingTypeId?.label) {
      setTrainingCodeSearch("")
      setSubTrainingCodeSearch("")
    }
    setTrainingTypeId(value)
  }

  const handleChooseTrainingCode = (value) => {
    if (!value) {
      setSubTrainingCodeSearch("")
    }
    if (value?.label !== trainingTypeId?.label) {
      setSubTrainingCodeSearch("")
    }
    setTrainingCode(value)
  }

  const handleChooseSubTrainingCode = (value) => {
    setSubTrainingCode(value)
  }

  const handleSearchPelatihan = () => {
    let url = "/pelatihan"

    // if (trainingTypeId?.id) {
    //   url += `?type=${trainingTypeId?.id}`
    // }

    // if (trainingCode?.id) {
    //   if (trainingTypeId?.id) {
    //     url += `&training-code=${trainingCode?.code}`
    //   } else {
    //     url += `?training-code=${trainingCode?.code}`
    //   }
    // }

    // if (subTrainingCode?.id) {
    //   if (subTrainingCode?.id) {
    //     url += `&sub-training-code=${subTrainingCode?.code}`
    //   } else {
    //     url += `?subtraining-code=${subTrainingCode?.code}`
    //   }
    //   return router.push(
    //     `/pelatihan/${String(subTrainingCode?.code).toLowerCase()}`,
    //   )
    // }

    if (choosedSubtraining?.id) {
      return router.push(
        `/pelatihan/${String(choosedSubtraining?.subTrainingCode).toLowerCase()}`,
      )
    }

    return router.push(url)
  }

  // console.log("choosedL", choosedSubtraining)

  // Background images for slideshow
  const backgroundImages = [
    { src: "/images/LOBBY (1).jpg", alt: "Lobby" },
    { src: "/images/PTSP (1).jpg", alt: "PTSP" },
    { src: "/images/RUANG RAPAT KAKAP (1).JPG", alt: "Ruang Rapat Kakap" },
    // { src: "/images/diklat.jpg", alt: "Diklat" },
    { src: "/images/kolam-renang.jpg", alt: "Kolam Renang" }
  ];

  return (
    <section className="relative min-h-[100dvh] bg-slate-950 overflow-hidden flex items-center justify-center pt-10">
      {/* Background Slideshow */}
      <div className="absolute inset-0 z-0">
        <BackgroundSlideshow images={backgroundImages} />
      </div>
      
      {/* Dynamic Overlay Gradients */}
      <div className="absolute inset-0 bg-gradient-to-b from-blue-950/80 via-blue-900/60 to-slate-950/90 z-0"></div>
      
      {/* Animated glowing orbs */}
      <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-blue-500/30 rounded-full blur-[120px] mix-blend-screen animate-pulse z-0 pointer-events-none"></div>
      <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] bg-cyan-400/20 rounded-full blur-[100px] mix-blend-screen animate-pulse delay-700 z-0 pointer-events-none"></div>

      <div className="relative z-10 w-full max-w-screen-xl px-4 py-20 flex flex-col justify-center items-center">
        {/* Header Content */}
        <div className="mx-auto max-w-4xl text-center mb-12 flex flex-col items-center">
          {/* Logo with glassmorphism glow */}
          <div className="relative inline-flex justify-center mb-8 group">
            <div className="absolute inset-0 bg-cyan-500/40 rounded-full blur-2xl group-hover:bg-cyan-400/60 transition-all duration-500"></div>
            <div className="relative bg-white/10 backdrop-blur-xl rounded-full p-6 border border-white/20 shadow-[0_0_30px_rgba(0,0,0,0.3)] group-hover:scale-105 group-hover:border-white/40 transition-all duration-300">
              <img 
                src="/images/simdiklat-logo.png" 
                alt="BPPP Tegal Logo" 
                className="w-24 h-24 object-contain filter drop-shadow-lg"
              />
            </div>
          </div>
          
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/5 backdrop-blur-md border border-white/10 rounded-full px-5 py-2 mb-6 hover:bg-white/10 transition-colors cursor-default shadow-lg">
            <span className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyan-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-cyan-500"></span>
            </span>
            <span className="text-cyan-50 text-xs sm:text-sm font-medium tracking-widest uppercase">
              Sistem Informasi Layanan Terintegrasi
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-2 leading-tight tracking-tight drop-shadow-2xl">
            Balai Pelatihan & Penyuluhan Perikanan
          </h1>
          <h2 className="text-5xl md:text-7xl lg:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 via-blue-200 to-cyan-300 mb-6 drop-shadow-[0_10px_10px_rgba(0,0,0,0.5)] tracking-widest uppercase">
            TEGAL
          </h2>
          <p className="text-blue-100/90 text-lg md:text-xl font-light max-w-2xl mx-auto mb-4 leading-relaxed">
            Pusat keunggulan pengembangan sumber daya manusia kelautan dan perikanan yang kompeten, profesional, dan berdaya saing global.
          </p>
        </div>
        
        {/* Search Section */}
        <div className="w-full max-w-2xl relative z-20">
          {/* Enhanced Call-to-Action Box */}
          <div className="bg-white/10 backdrop-blur-2xl rounded-[2.5rem] p-6 md:p-10 border border-white/20 shadow-[0_30px_60px_-15px_rgba(0,0,0,0.5)] relative overflow-hidden group">
            
            {/* Inner glow effect on hover */}
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/0 via-cyan-500/10 to-cyan-500/0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none"></div>
            
            <div className="text-center mb-8 relative z-10">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-2 flex items-center justify-center gap-3">
                <span className="bg-cyan-500/20 p-2 rounded-xl border border-cyan-500/30">🎯</span>
                Siap Meningkatkan Karir Anda?
              </h3>
              <p className="text-blue-100/80 text-base md:text-lg font-light">
                Jelajahi program unggulan kami untuk masa depan yang lebih cerah
              </p>
            </div>

            {/* Button directly to Pelatihan */}
            <div className="flex justify-center relative z-10">
               <Button
                 onClick={() => router.push('/pelatihan')}
                 className="w-full max-w-sm h-[64px] rounded-2xl bg-gradient-to-r from-cyan-500 to-blue-600 text-white hover:from-cyan-400 hover:to-blue-500 font-bold text-xl transition-all duration-300 transform hover:-translate-y-1 hover:shadow-[0_15px_30px_-10px_rgba(34,211,238,0.5)] shadow-lg border border-cyan-400/50 flex items-center justify-center gap-3">
                 Mulai Eksplorasi Pelatihan

                 <svg className="w-6 h-6 animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                 </svg>
               </Button>
            </div>

            {/* Additional Info / Features */}
            <div className="mt-10 pt-6 border-t border-white/10 flex flex-wrap justify-center gap-6 md:gap-8 text-sm text-blue-100/90 relative z-10">
              <div className="flex items-center gap-2 group/feature">
                <div className="w-8 h-8 rounded-full bg-cyan-500/20 flex items-center justify-center border border-cyan-500/30 group-hover/feature:bg-cyan-500/40 group-hover/feature:scale-110 transition-all">
                  <svg className="w-4 h-4 text-cyan-300" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <span className="font-medium tracking-wide">Sertifikat Resmi</span>
              </div>
              <div className="flex items-center gap-2 group/feature">
                <div className="w-8 h-8 rounded-full bg-cyan-500/20 flex items-center justify-center border border-cyan-500/30 group-hover/feature:bg-cyan-500/40 group-hover/feature:scale-110 transition-all">
                  <svg className="w-4 h-4 text-cyan-300" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <span className="font-medium tracking-wide">Instruktur Profesional</span>
              </div>
              <div className="flex items-center gap-2 group/feature">
                <div className="w-8 h-8 rounded-full bg-cyan-500/20 flex items-center justify-center border border-cyan-500/30 group-hover/feature:bg-cyan-500/40 group-hover/feature:scale-110 transition-all">
                  <svg className="w-4 h-4 text-cyan-300" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <span className="font-medium tracking-wide">Fasilitas Lengkap</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
